// extracted by mini-css-extract-plugin
module.exports = {"maxSiteWidth":"75rem","navMain":"_1l_CYR9gmnS_t0oxvnN9ZK"};